import { render, staticRenderFns } from "./KoutsuhiCard.vue?vue&type=template&id=233a20ba&scoped=true&"
import script from "./KoutsuhiCard.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiCard.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiCard.vue?vue&type=style&index=0&id=233a20ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a20ba",
  null
  
)

export default component.exports